<template>
    <div id="app">
        <!-- 路由出口：所有页面都会渲染到这里 -->
         <router-view />
    </div>
</template>

<script>
import { getSystemConfig } from '@/api/system.js';
import { Session } from '@/utils/storage';

export default {
    name: 'App',
    created() {
        // 应用启动时，加载系统配置（只执行一次）
        this.loadSystemConfig();
    },
    methods: {
        loadSystemConfig() {
            let that = this;
            getSystemConfig().then(res => {
                let systemConfig = res.data.system_info;
                document.title = systemConfig.web_name || '中技网-易学网';
                // 设置网站图标
                that.updateFavicon(systemConfig.web_logo || '')
                // 放入缓存
                if (res.code) {
                    Session.set('systemConfig', res.data);
                }
            });
        },
        // 辅助函数：专门修改favicon的小函数
        updateFavicon(iconUrl) {
            if (!iconUrl) return;
            // 先找页面里已有的favicon标签
            let link = document.querySelector('link[rel="icon"]')

            // 识别文件的后缀
            let ext = iconUrl.substring(iconUrl.lastIndexOf('.') + 1)
            if (ext === 'ico') {
                link.type = 'image/x-icon'
            } else {
                link.type = 'image/png'
            }
            iconUrl = process.env.VUE_APP_STATIC_URL + iconUrl;
        
            // 如果没有，就新建一个
            if (!link) {
                link = document.createElement('link')
                link.rel = 'icon'
                document.head.appendChild(link)
            }

            // 替换icon地址（立刻生效）
            link.href = iconUrl
        }
    }
};
</script>

<style>
    /* 全局样式重置 */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }
</style>